import { newDate } from '@toy/utils';

interface LabelListItem<T = any> {
  value: T;
  label: string;
}
// 根据 val 获取数组中对应的 label
export function getLabelByVal<T>(arr: LabelListItem<T>[], val: string) {
  const item = arr.find(it => String(it.value) === String(val)) as LabelListItem<T> || {};
  return item.label || '';
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function isEmpty(val: any): boolean {
  return val === null || val === '' || val === undefined;
}

/**
 * 跳到指定日期的n天前后
 * @param {string | number | Date} startDate 时间
 * @param {string | number} days 跳几天(小数会向下取整)
 * @param {string} [defaultValue = '-'] 默认返回值
 * @returns {string} n天后日期
 * @example
 * ```typescript
 * 1. jumpDays(2012-2-28', 10) => '2012-03-09';
 * 2. jumpDays('2012-3-10', -20') => '2012-02-19';
 * 3. jumpDays(1622025138022, -20) => '2021-05-06';
 * 4. jumpDays('2012-2-28', 1.5) => '2012-02-29';
 */
export function jumpDays(
  startDate: string | number | Date,
  days: string | number,
  defaultValue = '-',
): string {
  if (isEmpty(startDate) || isEmpty(days)) {
    return defaultValue;
  }
  const d = newDate(startDate);
  d.setDate(d.getDate() + Math.floor(Number(days)));
  let mon: string | number = d.getMonth() + 1;
  let day: string | number = d.getDate();
  mon = mon < 10 ? `0${mon}` : mon;
  day = day < 10 ? `0${day}` : day;
  return `${d.getFullYear()}-${mon}-${day}`;
}

/**
 * 深克隆
 * @param {any} item 传入的值
 * @return {any}  深克隆后的值
 * @example
 * ``` typescript
 * 1. deepClone({ a: 123, b: [{ c: 456 }] }) => { a: 123, b: [{ c: 456 }] }
 * 2. deepClone(null) => null
 * 3. deepClone([123, 456]) => [123, 456]
 */
export function deepClone<T>(item: T): T {
  let copy: any;
  if (item === null || typeof item !== 'object') {
    return item;
  }
  // array
  if (item instanceof Array) {
    copy = [];
    const len = item.length;
    for (let i = 0; i < len; i++) {
      // 循环深克隆
      copy[i] = deepClone(item[i]);
    }
    return copy;
  }
  // object
  if (item instanceof Object) {
    copy = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const val in item) {
      if (Object.prototype.hasOwnProperty.call(item, val)) {
        copy[val] = deepClone(item[val]);
      }
    }
    return copy;
  }
  // date
  if (item instanceof Date) {
    copy = new Date();
    copy.setTime(item.getTime());
    return copy;
  }
  throw new Error("Unable to copy item! Its type isn't supported.");
}
